import { useQuery, useQueryClient } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import i18n from "i18n";
const SETTINGS_URL = "/plugins/org.graylog.plugins.license/licenses/traffic-limit-violations/settings";
export const TRAFFIC_LIMIT_VIOLATION_CONFIG_QUERY_KEY = ["traffic-violation", "config"];
const fetchTrafficLimitViolationConfig = () => SystemLicenses.getTrafficLimitViolationSettings().then((response) => response.email_recipients).catch((error) => {
  UserNotification.error(
    i18n.t("notifications.load_traffic_violation_config_failed", {
      ns: "enterprise_license",
      error: String(error)
    }),
    i18n.t("notifications.load_traffic_violation_config_failed_title", { ns: "enterprise_license" })
  );
  return void 0;
});
export const updateTrafficLimitViolationConfig = (config) => {
  const url = qualifyUrl(SETTINGS_URL);
  return fetch("PUT", url, config).catch((error) => {
    UserNotification.error(
      i18n.t("notifications.save_traffic_violation_config_failed", { ns: "enterprise_license", error: String(error) }),
      i18n.t("notifications.save_traffic_violation_config_failed_title", { ns: "enterprise_license" })
    );
    throw error;
  });
};
const useTrafficLimitViolationConfig = () => {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: TRAFFIC_LIMIT_VIOLATION_CONFIG_QUERY_KEY,
    queryFn: fetchTrafficLimitViolationConfig,
    retry: false
  });
  const invalidate = () => queryClient.invalidateQueries({ queryKey: TRAFFIC_LIMIT_VIOLATION_CONFIG_QUERY_KEY });
  return {
    emailRecipients: data,
    invalidateTrafficLimitViolationConfig: invalidate
  };
};
export default useTrafficLimitViolationConfig;
